import { ApiAccountScoreBucket } from 'shared/graphql/generatedApiTypes';

export const colorsByScoreBucket = {
  [ApiAccountScoreBucket.VeryUnlikely]: '#f7fcfd',
  [ApiAccountScoreBucket.Unlikely]: '#e5f5f9',
  [ApiAccountScoreBucket.Tossup]: '#ccece6',
  [ApiAccountScoreBucket.Likely]: '#99d8c9',
  [ApiAccountScoreBucket.VeryLikely]: '#66c2a4',
};
